import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Badge,
  CTA,
  Checkbox,
  HtmlRaw,
  Icon,
  RadioButton,
  Text,
} from '../../atoms';
import {
  Answer,
  AnswerWrapper,
  ButtonContainer,
  MobileQuiz,
  Question,
  QuizContainer,
  QuizGlobalWrapper,
  QuizWrapper,
  TabsWrapper,
} from './style';
import {
  QUIZ_RESET,
  QUIZ_SEND_ANSWERS,
  QUIZ_START_TRACKING,
} from '../../../app/redux/actions/coursedetails';
import Tabs from '../../atoms/Tabs';
import QuizResult from './QuizResult';
import { withMediaQueries } from '../../../app/hoc/withMediaQueries';
import { MODAL_OPEN } from '../../../app/redux/actions';
import ModalQuiz, { ModalQuizId } from '../../atoms/Modals/ModalQuiz';

const defaultTabs = [
  {
    label: 1,
    value: 1,
  },
];

export const RenderAnswerType = ({
  qid,
  label,
  onClick,
  type,
  disabled,
  checked,
}) => {
  if (type === 'multiple_choice') {
    return (
      <Checkbox
        label={label}
        onChange={onClick}
        name={qid.toString()}
        disabled={disabled}
        className="quiz"
        checked={checked}
      />
    );
  }
  return (
    <RadioButton
      label={label}
      onChange={onClick}
      name={qid.toString()}
      disabled={disabled}
      className="quiz"
      checked={checked}
    />
  );
};
RenderAnswerType.propTypes = {
  qid: PropTypes.number,
  label: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
};

const Quiz = ({
  mediaIsPhone,
  data: { elements: data },
  duration,
  sendQuizAnsers,
  activity_id,
  quiz = {},
  title,
  quizReset,
  isCompleted,
  modalOpen,
  quizStartTracking,
}) => {
  const { correct_answers, my_answers, quiz_passed } = quiz;
  const [answers, setAnswers] = useState({});
  const [tabs, setTabs] = useState(defaultTabs);
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [showSummary, setShowSummary] = useState(false);
  const [showResults, setShowResults] = useState(false);

  useEffect(() => {
    quizStartTracking(activity_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activity_id]);

  const handleOnClick = ({ qid, type, aid }) => {
    const newAnswers = { ...answers };
    if (type === 'multiple_choice') {
      newAnswers[qid] = answers[qid]?.length > 0 ? [...answers[qid]] : [];
      const aIndex = newAnswers[qid].findIndex((e) => e === aid);
      aIndex < 0
        ? newAnswers[qid].push(aid)
        : newAnswers[qid].splice(aIndex, 1);
    } else {
      newAnswers[qid] = [aid];
    }
    setAnswers(newAnswers);
    checkQuestionCompleted(qid, newAnswers);
  };

  const disableCheckbox = (q, aid) => {
    if (typeof quiz_passed === 'boolean') return true;
    if (q?.question_type === 'multiple_choice') {
      return (
        q?.number_of_required_answers === answers[q?.question_id]?.length &&
        !answers[q?.question_id]?.includes(aid)
      );
    }
    return false;
  };

  const quizIsCompleted = () => {
    let completed = Object.keys(answers)?.length === data?.length;
    (Object.keys(answers) || []).forEach((qid) => {
      const question = data.find((q) => q?.question_id === Number(qid));
      completed =
        completed &&
        question?.number_of_required_answers === answers[qid]?.length;
    });
    return completed;
  };

  const sendAnswers = () => {
    const body = Object.keys(answers)?.map((qid) => ({
      question_id: qid,
      answer_ids: answers[qid],
    }));
    sendQuizAnsers(activity_id, body);
  };

  const getClasses = (qid, aid) => {
    let classes = '';
    if (!correct_answers || !my_answers) return classes;

    if (my_answers[qid]?.includes(aid)) classes = 'wrong';
    if (correct_answers[qid]?.includes(aid)) classes = 'correct';

    return classes;
  };

  const isChecked = (qid, aid) => {
    if (my_answers && Object.keys(my_answers)?.length > 0) {
      return my_answers[qid]?.includes(aid);
    }
    return answers[qid]?.findIndex((ans_id) => ans_id === aid) >= 0;
  };

  useEffect(() => {
    if (isCompleted) sendAnswers();
    return () => {
      quizReset();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCompleted]);

  useEffect(() => {
    if (typeof quiz_passed === 'boolean') {
      setShowResults(true);
    } else setShowResults(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quiz_passed]);

  useEffect(() => {
    const newtabs = (data || []).map((t, i) => ({
      label: i < 10 ? `0${i + 1}` : i + 1,
      value: i + 1,
    }));
    setTabs(newtabs);
    setActiveTab(newtabs[0]);
  }, [data]);

  const checkQuestionCompleted = (qid, newAnswers) => {
    const requiredAnswers = data.find(
      (q) => q?.question_id === qid
    )?.number_of_required_answers;
    const newTabs = [...tabs];
    if (newAnswers[qid]?.length === requiredAnswers) {
      newTabs[activeTab.value - 1].class = 'completed';
    } else newTabs[activeTab.value - 1].class = '';
  };

  const retry = () => {
    quizReset();
    setAnswers({});
    setShowSummary(false);
    setShowResults(false);
    setActiveTab(tabs[0]);
  };

  if (mediaIsPhone) {
    return (
      <>
        <MobileQuiz>
          <Icon type="file-06" size={26} />
          <div>
            <Text type="b4" mb={8}>
              Quiz di verifica del corso:
            </Text>
            <Text type="h3.5" mb={10}>
              <b>{title}</b>
            </Text>
          </div>
          <CTA
            btnText="Inizia il quiz"
            fullsize
            onClick={() => modalOpen(ModalQuizId)}
          />
        </MobileQuiz>
        <ModalQuiz
          data={data}
          isCompleted={isCompleted}
          duration={duration}
          activity_id={activity_id}
        />
      </>
    );
  }

  return (
    <QuizGlobalWrapper>
      <div className="quiz-info">
        <Text type="b2" mb={8}>
          Quiz di verifica del corso:
        </Text>
        <Text type="h2.5" mb={10}>
          {title}
        </Text>
        <div className="duration">
          <Text type="b4">
            {duration}min <Icon type="clock" />
          </Text>
          <Text type="b4">{data?.length} domande totali</Text>
        </div>
      </div>
      {!showResults && (
        <TabsWrapper>
          <Tabs
            tabs={tabs}
            onChange={(t) => {
              if (showSummary) setShowSummary(false);
              setActiveTab(t);
            }}
            selected={activeTab}
            tabType="secondary"
          />
        </TabsWrapper>
      )}
      {showResults ? (
        <QuizResult quiz={quiz} retry={retry} />
      ) : showSummary ? (
        <div>
          <Text type="h3" mb={34}>
            Riepilogo risposte
          </Text>
          {data?.map((q, i) => {
            return (
              <QuizWrapper key={q.question_id} className="resume">
                <Question>
                  <Text type="h3">
                    {i + 1}. {q.question}
                  </Text>
                  <Badge type="news">
                    {q?.number_of_required_answers <= 1
                      ? '1 punto'
                      : `${q?.number_of_required_answers} punti`}
                  </Badge>
                </Question>
                <AnswerWrapper
                  className="resume"
                  onClick={() => {
                    setShowSummary(false);
                    setActiveTab(tabs[i]);
                  }}
                >
                  <div>
                    {answers[q.question_id]?.length > 0 ? (
                      answers[q.question_id].map((aid, index) => (
                        <Text
                          type="b3"
                          key={`answer-${index}`}
                          className="answer"
                        >
                          {(q?.answers || []).find((ans) => ans?.id === aid)
                            ?.value || '-'}
                        </Text>
                      ))
                    ) : (
                      <Text type="b3">-</Text>
                    )}
                  </div>
                  <CTA btnText="modifica" icon="edit-05" type="tertiary" />
                </AnswerWrapper>
              </QuizWrapper>
            );
          })}
          <ButtonContainer>
            <CTA
              btnText="modifica"
              type="secondary"
              onClick={() => {
                setActiveTab(tabs[0]);
                setShowSummary(false);
              }}
            />
            <CTA
              btnText="conferma"
              onClick={sendAnswers}
              disabled={!quizIsCompleted()}
            />
          </ButtonContainer>
        </div>
      ) : (
        <QuizContainer>
          {data?.map((q, i) => {
            if (i + 1 !== activeTab?.value) return null;
            return (
              <QuizWrapper key={q.question_id}>
                <Question>
                  <Text type="h3">
                    <HtmlRaw html={`${i + 1}. ${q.question}`} />
                  </Text>
                  <Badge type="news">
                    {q?.number_of_required_answers <= 1
                      ? '1 punto'
                      : `${q?.number_of_required_answers} punti`}
                  </Badge>
                </Question>
                <AnswerWrapper>
                  {q?.answers?.map((a) => (
                    <Answer
                      key={a?.id}
                      className={getClasses(q?.question_id, a?.id)}
                    >
                      <RenderAnswerType
                        label={a?.value?.replaceAll('<br />', ' ')}
                        onClick={() =>
                          handleOnClick({
                            qid: q?.question_id,
                            aid: a?.id,
                            type: q?.question_type,
                          })
                        }
                        type={q?.question_type}
                        qid={q?.question_id}
                        disabled={disableCheckbox(q, a?.id)}
                        checked={isChecked(q?.question_id, a?.id)}
                      />
                    </Answer>
                  ))}
                </AnswerWrapper>
              </QuizWrapper>
            );
          })}
          <ButtonContainer>
            <CTA
              btnText="indietro"
              type="secondary"
              onClick={() => {
                setActiveTab(tabs[activeTab.value - 2]);
              }}
              disabled={activeTab.value === 1}
            />
            <CTA
              btnText={quizIsCompleted() ? 'vai al riepilogo' : 'avanti'}
              onClick={() => {
                if (quizIsCompleted() || activeTab.value === tabs?.length) {
                  setActiveTab();
                  setShowSummary(true);
                } else setActiveTab(tabs[activeTab.value]);
              }}
            />
          </ButtonContainer>
        </QuizContainer>
      )}
    </QuizGlobalWrapper>
  );
};

Quiz.propTypes = {
  mediaIsPhone: PropTypes.bool,
  data: PropTypes.object.isRequired,
  activity_id: PropTypes.number,
  duration: PropTypes.number,
  isCompleted: PropTypes.bool,

  // HOC (connect, state)
  quiz: PropTypes.object,
  title: PropTypes.string,

  // HOC (connect, dispatch)
  sendQuizAnsers: PropTypes.func,
  quizReset: PropTypes.func,
  modalOpen: PropTypes.func,
  quizStartTracking: PropTypes.func,
};

export default connect(
  (state) => {
    const { quiz, title } = state.coursedetails;
    return {
      quiz,
      title,
    };
  },
  (dispatch) => ({
    sendQuizAnsers: (activity_id, body) =>
      dispatch({ type: QUIZ_SEND_ANSWERS._REQUEST, activity_id, body }),
    quizReset: () => dispatch({ type: QUIZ_RESET }),
    modalOpen: (id) => dispatch({ type: MODAL_OPEN, id }),
    quizStartTracking: (id) =>
      dispatch({ type: QUIZ_START_TRACKING._REQUEST, id }),
  })
)(withMediaQueries(Quiz));
